// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InternalDocTypeResolver } from '@services/resolvers/internal-doc-type.resolver';
import { DocUploadTypeResolver } from '@services/resolvers/doc-upload-type.resolver';
import { DocumentResolver } from '@services/resolvers/document.resolver';
import { TemplateListResolver } from '@services/resolvers/template-list.resolver';
import { UserResolver } from '@services/resolvers/user.resolver';
import { PendingChangesGuard } from '@services/route-guards/pending-changes.guard';
import { FormsComponent } from './forms/forms.component';
import { DealershipResolver } from '@services/resolvers/dealership.resolver';
import { FAndIFormsGuard } from '@services/route-guards/permissions/f-and-i-forms.guard';

const routes: Routes = [
    {
        path: '',
        component: FormsComponent,
        resolve: {
            coreForms: TemplateListResolver,
            user: UserResolver,
            internalDocTypes: InternalDocTypeResolver,
            uploadTypes: DocUploadTypeResolver,
            dealerships: DealershipResolver,
        },
        canDeactivate: [PendingChangesGuard],
        canActivate: [FAndIFormsGuard],
    },
    {
        path: ':docId',
        loadChildren: () => import('../forms-container/dealer-edit-form-routing.module').then((m) => m.DealerEditFormRoutingModule),
        resolve: {
            doc: DocumentResolver,
        },
        canActivate: [FAndIFormsGuard],
    },
    {
        path: '**',
        redirectTo: '',
        pathMatch: 'full',
    },
];
@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class DealerFormsRoutingModule {}
